var _g, _g2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardCardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 134,
    viewBox: "0 0 156 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4501_326)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.9792,
    cy: 43.0763,
    rx: 78.861,
    ry: 71.0486,
    transform: "rotate(-16.7881 96.9792 43.0763)",
    fill: "#A8ADB9",
    fillOpacity: 0.41
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4501_326)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.9208,
    cy: 41.8601,
    rx: 75.3233,
    ry: 67.2161,
    transform: "rotate(-16.7881 96.9208 41.8601)",
    fill: "#0096D1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.889 81H83.1111C76.9722 81 72 76.0278 72 69.8889V42.1111C72 35.9722 76.9722 31 83.1111 31H110.889C117.028 31 122 35.9722 122 42.1111V69.8889C122 76.0278 117.028 81 110.889 81Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.111 76H85.8889C80.9778 76 77 72.0222 77 67.1111V44.8889C77 39.9778 80.9778 36 85.8889 36H108.111C113.022 36 117 39.9778 117 44.8889V67.1111C117 72.0222 113.022 76 108.111 76Z",
    fill: "#012063"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106 64.2499H95.9997C95.5897 64.2499 95.2497 63.9099 95.2497 63.4999C95.2497 63.0899 95.5897 62.7499 95.9997 62.7499H106C106.41 62.7499 106.75 63.0899 106.75 63.4999C106.75 63.9099 106.41 64.2499 106 64.2499ZM106 57.2499H95.9997C95.5897 57.2499 95.2497 56.9099 95.2497 56.4999C95.2497 56.0899 95.5897 55.7499 95.9997 55.7499H106C106.41 55.7499 106.75 56.0899 106.75 56.4999C106.75 56.9099 106.41 57.2499 106 57.2499ZM106 50.2499H95.9997C95.5897 50.2499 95.2497 49.9099 95.2497 49.4999C95.2497 49.0899 95.5897 48.7499 95.9997 48.7499H106C106.41 48.7499 106.75 49.0899 106.75 49.4999C106.75 49.9099 106.41 50.2499 106 50.2499ZM88.9997 51.2509C88.8097 51.2509 88.6197 51.1809 88.4697 51.0309L87.4697 50.0309C87.3302 49.8898 87.252 49.6993 87.252 49.5009C87.252 49.3025 87.3302 49.1121 87.4697 48.9709C87.7597 48.6809 88.2397 48.6809 88.5297 48.9709L88.9997 49.4409L91.4697 46.9709C91.7597 46.6809 92.2397 46.6809 92.5297 46.9709C92.8197 47.2609 92.8197 47.7409 92.5297 48.0309L89.5297 51.0309C89.3797 51.1809 89.1897 51.2509 88.9997 51.2509ZM88.9997 58.2509C88.8097 58.2509 88.6197 58.1809 88.4697 58.0309L87.4697 57.0309C87.3302 56.8898 87.252 56.6993 87.252 56.5009C87.252 56.3025 87.3302 56.1121 87.4697 55.9709C87.7597 55.6809 88.2397 55.6809 88.5297 55.9709L88.9997 56.4409L91.4697 53.9709C91.7597 53.6809 92.2397 53.6809 92.5297 53.9709C92.8197 54.2609 92.8197 54.7409 92.5297 55.0309L89.5297 58.0309C89.3797 58.1809 89.1897 58.2509 88.9997 58.2509ZM88.9997 65.2509C88.8097 65.2509 88.6197 65.1809 88.4697 65.0309L87.4697 64.0309C87.3302 63.8898 87.252 63.6993 87.252 63.5009C87.252 63.3025 87.3302 63.1121 87.4697 62.9709C87.7597 62.6809 88.2397 62.6809 88.5297 62.9709L88.9997 63.4409L91.4697 60.9709C91.7597 60.6809 92.2397 60.6809 92.5297 60.9709C92.8197 61.2609 92.8197 61.7409 92.5297 62.0309L89.5297 65.0309C89.3797 65.1809 89.1897 65.2509 88.9997 65.2509Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4501_326",
    x: 18.7207,
    y: -32.4273,
    width: 156.518,
    height: 147.256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.75104
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.6888
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4501_326"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4501_326",
    x: 20.3462,
    y: -26.0879,
    width: 153.149,
    height: 139.647,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.87552
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.937759
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0 0.3 0 0 0 0.67 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4501_326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4501_326",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCardBg);
export default __webpack_public_path__ + "static/media/dashboard-card-bg.063b6e38b3571e50a9e6b507aec38249.svg";
export { ForwardRef as ReactComponent };